import type { ApiError } from '../../../lib/errors';
import { maLoi } from '../../../lib/errors';

/** Khoá cache của module `rpa`. Mọi khoá bắt đầu bằng `goc` để làm mới cả module bằng một lệnh. */
export const KHOA_RPA = {
  goc: ['rpa'] as const,
  loi: ['rpa', 'loi'] as const,
  tongQuanCode: ['rpa', 'loi', 'codes'] as const,
  code: (code: string) => ['rpa', 'loi', 'code', code] as const,
  cho: (status: string) => ['rpa', 'loi', 'cho', status] as const,
  phanLoai: ['rpa', 'loi', 'phan-loai'] as const,
  ketNoi: ['rpa', 'ket-noi'] as const,
  projects: ['rpa', 'projects'] as const,
  workflows: ['rpa', 'workflows'] as const,
  soDo: (id: string) => ['rpa', 'so-do', id] as const,
  giaTri: (id: string) => ['rpa', 'gia-tri', id] as const,
  lichSuGiaTri: (id: string) => ['rpa', 'gia-tri', id, 'lich-su'] as const,
  lienKet: ['rpa', 'lien-ket'] as const,
  tuyChonChay: (id: string) => ['rpa', 'chay', id, 'tuy-chon'] as const,
  luotGanNhat: (id: string) => ['rpa', 'chay', id, 'gan-nhat'] as const,
  lichSu: ['rpa', 'lich-su'] as const,
  trangLichSu: (q: object) => ['rpa', 'lich-su', 'trang', q] as const,
  baoCaoInstance: (id: string) => ['rpa', 'lich-su', 'bao-cao', 'instance', id] as const,
  baoCaoLuot: (ma: string) => ['rpa', 'lich-su', 'bao-cao', 'luot', ma] as const,
  logInstance: (id: string) => ['rpa', 'lich-su', 'log', id] as const,
  dongThoiGian: (ma: string) => ['rpa', 'lich-su', 'dong-thoi-gian', ma] as const,
  tepBangChung: (exec: string, tep: string) => ['rpa', 'tep-bang-chung', exec, tep] as const,
  duLieu: (luot: string) => ['rpa', 'du-lieu', luot] as const,
  suCo: ['rpa', 'su-co'] as const,
  tongQuan: ['rpa', 'tong-quan'] as const,
  soLieuTongQuan: (q: object) => ['rpa', 'tong-quan', 'so-lieu', q] as const,
  instancesTongQuan: (q: object) => ['rpa', 'tong-quan', 'instances', q] as const,
  licenses: ['rpa', 'license'] as const,
  quyenLicense: (id: string) => ['rpa', 'license', 'quyen', id] as const,
  danhBaOpenCore: ['rpa', 'danh-ba'] as const,
  usersOpenCore: ['rpa', 'danh-ba', 'users'] as const,
  rolesOpenCore: ['rpa', 'danh-ba', 'roles'] as const,
  thongBao: ['rpa', 'thong-bao'] as const,
  quyTacThongBao: ['rpa', 'thong-bao', 'quy-tac'] as const,
  kenhThongBao: ['rpa', 'thong-bao', 'kenh'] as const,
  taiKhoanGui: ['rpa', 'thong-bao', 'tai-khoan-gui'] as const,
  agent: ['rpa', 'agent'] as const,
  trangThaiAgent: ['rpa', 'agent', 'trang-thai'] as const,
  taskAgent: ['rpa', 'agent', 'task'] as const,
  xemTruocHanhDong: (id: string, i: number) => ['rpa', 'agent', 'xem-truoc', id, i] as const,
};

/**
 * 4xx là câu trả lời của máy chủ, không phải trục trặc: thử lại chỉ bắt người dùng chờ thêm. `503` có `error_code`
 * riêng (`RPA_OPENCORE_NOT_CONFIGURED`) cũng là câu trả lời — tenant chưa khai kết nối, hỏi lại không khác đi.
 */
export function thuLai(soLanDaThu: number, err: unknown): boolean {
  const status = (err as ApiError | undefined)?.status;
  if (status !== undefined && status >= 400 && status < 500) return false;
  if (maLoi(err)?.startsWith('RPA_')) return false;
  return soLanDaThu < 1;
}

/** Tenant chưa khai, đang tắt hoặc thiếu JWT của kết nối OpenCore: màn hướng dẫn sang tab Kết nối, không báo lỗi chung. */
export function laChuaKhaiKetNoi(err: unknown): boolean {
  return maLoi(err) === 'RPA_OPENCORE_NOT_CONFIGURED';
}
